// Port of api/fuel/app/classes/model/hindex/track.php
import Model from 'offline/stream/model/base'
import HindexType from 'offline/model/hindex/type'

export default Model.extend({
	table: 'hindex_track',
	prefix: 'track',
	key: 'track_id',
	fields: {
		track_id: Model.SCHEMA_KEY,
		hindex_id: Model.SCHEMA_NUMBER,
		user_id: Model.SCHEMA_NUMBER,
		track_generated: Model.SCHEMA_NUMBER,
		track_hindex: Model.SCHEMA_NUMBER,
		track_concentration: Model.SCHEMA_NUMBER,
		track_bias: Model.SCHEMA_NUMBER,
		track_share: Model.SCHEMA_NUMBER,
		track_coverage: Model.SCHEMA_NUMBER,
		track_efficiency: Model.SCHEMA_NUMBER,
		track_plays: Model.SCHEMA_NUMBER
	},
	methods: {
		to_json: function() {
			var type = HindexType.with_id(this.get_hindex_id())
			return {
				name: type ? type.get_name() : '',
				slug: type ? type.get_slug() : '',
				generated: this.get_generated() || 0
			}
		}
	}
})
